/* Velocity v2 — Strahda build */
(function(){
  // Mobile menu
  document.addEventListener('click', function(e){
    var btn = e.target.closest('[data-mobile-menu]');
    if(btn){
      var open = document.body.classList.toggle('menu-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      return;
    }
    if(e.target.closest('[data-menu-close]') || (document.body.classList.contains('menu-open') && e.target.classList.contains('mobile-drawer__overlay'))){
      document.body.classList.remove('menu-open');
      var b = document.querySelector('[data-mobile-menu]');
      if(b) b.setAttribute('aria-expanded','false');
    }
  });
  document.addEventListener('keydown', function(e){
    if(e.key === 'Escape' && document.body.classList.contains('menu-open')){
      document.body.classList.remove('menu-open');
    }
  });

  // Product variant handling
  var form = document.querySelector('[data-product-form]');
  if(!form) return;
  var dataEl = document.querySelector('[data-product-json]');
  if(!dataEl) return;
  var product;
  try { product = JSON.parse(dataEl.textContent); } catch(err){ return; }
  var select = form.querySelector('select[name="id"]');
  if(!select) return;
  var priceEl = document.querySelector('[data-price]');
  var compareEl = document.querySelector('[data-compare-price]');
  var btn = form.querySelector('[data-add-to-cart]');

  function money(cents){
    var amount = (cents/100).toFixed(2);
    var fmt = (window.Shopify && Shopify.money_format) || dataEl.getAttribute('data-money-format') || '£{{amount}}';
    return fmt.replace(/\{\{\s*amount\s*\}\}/, amount);
  }

  select.addEventListener('change', function(){
    var v = product.variants.find(function(x){ return String(x.id) === select.value; });
    if(!v) return;
    if(priceEl) priceEl.textContent = money(v.price);
    if(compareEl){
      if(v.compare_at_price && v.compare_at_price > v.price){
        compareEl.textContent = money(v.compare_at_price);
        compareEl.hidden = false;
      } else { compareEl.hidden = true; }
    }
    if(btn){
      btn.disabled = !v.available;
      btn.textContent = v.available ? btn.getAttribute('data-label-add') : btn.getAttribute('data-label-sold');
    }
    var url = new URL(window.location.href);
    url.searchParams.set('variant', v.id);
    window.history.replaceState({}, '', url.toString());
  });
})();
